import { Button, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppSelector } from "../../../../app/store";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import SuccessModal from "../../../../components/common/SuccessModal";
import {
  useCreateWorkFlowMutation,
  useGetAllProductQuery,
  useGetAllRoleQuery,
  useGetSingleWorkFlowQuery,
  useUpdateWorkFlowMutation,
} from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";

export default function ApprovalDynamic() {
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(
    null
  );
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const { open, handleOpen, handleClose } = useModal();
  const [form] = Form.useForm();
  const backLink = "/admin/users-roll-access/approval-dynamic-list";
  const navigate = useNavigate();
  const { id } = useParams();

  const { user } = useAppSelector((state) => state.auth);

  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      limit: 100000,
      page: 1,
    },
  });

  const {
    isError: isAllRoleError,
    error: allRoleError,
    data: allRoleData,
  } = useGetAllRoleQuery({
    params: {
      projectId: selectedProjectId,
    },
  });
  const [
    createWorkFlow,
    {
      isError: isCreateWorkFlowError,
      error: createWorkFlowError,
      isLoading: isCreateWorkFlowLoading,
      isSuccess: isCreateWorkFlowSuccess,
    },
  ] = useCreateWorkFlowMutation();

  const [
    updateWorkFlow,
    {
      isError: updateWorkFlowIsError,
      error: updateWorkFlowError,
      isLoading: updateWorkFlowLoading,
      isSuccess: updateWorkFlowIsSuccess,
    },
  ] = useUpdateWorkFlowMutation();

  const {
    isError: getSingleWorkFlowIsError,
    error: getSingleWorkFlowError,
    data: getSingleWorkFlowData,
  } = useGetSingleWorkFlowQuery(
    { id },
    {
      skip: !id,
    }
  );

  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isAllRoleError, allRoleError, "Get all roll fail");
  useError(isCreateWorkFlowError, createWorkFlowError, "Work Flow create fail");
  useError(
    getSingleWorkFlowIsError,
    getSingleWorkFlowError,
    "Work Flow create fail"
  );
  useError(updateWorkFlowIsError, updateWorkFlowError, "Workflow update fail");

  const allProduct = getAllProduct?.data?.data;
  const allsRollData = allRoleData?.data?.data;
  const singleWorkFlowData = getSingleWorkFlowData?.data;

  const onFinish = (values: any) => {
    const newData = {
      projectId: Number(values?.projectId),
      roleId: Number(values?.roleId),
      amountFrom: Number(values?.amountFrom),
      amountTo: Number(values?.amountTo),
      poolANumber: Number(values?.poolANumber),
      poolBNumber: Number(values?.poolBNumber),
      companyId: user?.data?.company_id,
    };

    if (id) {
      updateWorkFlow({
        id,
        data: newData,
      });
    } else {
      createWorkFlow(newData);
    }
  };

  const handleOkay = () => {
    handleClose();
    navigate(`/admin/users-roll-access/approval-dynamic-list`);
  };

  useEffect(() => {
    if (id && singleWorkFlowData) {
      form.setFieldsValue({
        projectId: Number(singleWorkFlowData?.projectId),
        roleId: Number(singleWorkFlowData?.roleId),
        amountFrom: Number(singleWorkFlowData?.amountFrom),
        amountTo: Number(singleWorkFlowData?.amountTo),
        poolANumber: Number(singleWorkFlowData?.poolANumber),
        poolBNumber: Number(singleWorkFlowData?.poolBNumber),
        companyId: user?.data?.company_id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, singleWorkFlowData]);

  useEffect(() => {
    if (isCreateWorkFlowSuccess) {
      form.resetFields();
      handleOpen({ type: "ADD" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateWorkFlowSuccess]);

  useEffect(() => {
    if (updateWorkFlowIsSuccess) {
      toast("success", "Approval dynamic updated successfully!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateWorkFlowIsSuccess]);

  // useEffect(() => {
  //   if (id && singleWorkFlowData) {
  //     form.setFieldsValue({
  //       // ...other fields...
  //       roleId: Number(singleWorkFlowData?.roleId),
  //       // ...other fields...
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [id, singleWorkFlowData]);

  return (
    <>
      {open?.type === "ADD" && (
        <SuccessModal
          open={open?.open}
          handleClose={handleClose}
          handleOkay={handleOkay}
          data={open?.data}
          title="Successfully work flow created"
        />
      )}

      <SidebarLayout title={`Approval Dynamic Add`} backLink={backLink}>
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <CardTitle>Approval Dynamic </CardTitle>

            <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-x-6 pt-4 mb-6">
              <div className="flex justify-center items-center gap-2">
                <Form.Item
                  label="Amount"
                  name="amountFrom"
                  rules={[
                    { required: true, message: "Please enter amount" },
                    {
                      validator: (_, value) => {
                        if (value === undefined || value === "")
                          return Promise.resolve();
                        if (isNaN(value))
                          return Promise.reject("Amount must be a number");
                        if (Number(value) < 0)
                          return Promise.reject("Negative numbers not allowed");
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="amount"
                    type="number"
                    min={0}
                    disabled={!!id}
                  />
                </Form.Item>

                <div className="mt-5">to</div>

                <Form.Item
                  label={<span className="invisible">Amount</span>}
                  name="amountTo"
                  dependencies={["amountFrom"]} // For cross-field validation
                  rules={[
                    { required: true, message: "Please enter amount" },
                    {
                      validator: (_, value, callback) => {
                        return new Promise((resolve, reject) => {
                          const amountFrom = form.getFieldValue("amountFrom");

                          if (value === undefined || value === "")
                            return resolve(undefined);
                          if (isNaN(value))
                            return reject("Amount must be a number");
                          if (Number(value) < 0)
                            return reject("Negative numbers not allowed");

                          if (
                            amountFrom !== undefined &&
                            Number(value) <= Number(amountFrom)
                          ) {
                            return reject(
                              "Amount To must be greater than Amount From"
                            );
                          }

                          return resolve(undefined);
                        });
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="amount"
                    type="number"
                    min={0}
                    disabled={!!id}
                  />
                </Form.Item>
              </div>

              <Form.Item
                label="Pool A"
                name="poolANumber"
                rules={[{ required: true, message: "Please Select Pool A" }]}
              >
                <Input placeholder="Pool A Number" />
              </Form.Item>

              <Form.Item
                label="Pool B"
                name="poolBNumber"
                rules={[{ required: true, message: "Please Select Pool B" }]}
              >
                <Input placeholder="Pool B Number" />
              </Form.Item>

              <Form.Item
                label="Select Project"
                name="projectId"
                rules={[{ required: true, message: "Please select project" }]}
              >
                <Select
                  placeholder="Select Project"
                  showSearch
                  options={
                    allProduct?.map((project: any) => ({
                      label: project?.name,
                      value: project?.id,
                    })) || []
                  }
                  onChange={(value) => setSelectedProjectId(value)}
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                  disabled={!!id}
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item
                label="Select Role"
                name="roleId"
                hidden={id ? true : false}
                rules={[{ required: true, message: "Please select role" }]}
              >
                <Select
                  placeholder="Select Role"
                  options={
                    allsRollData?.map((role: any) => ({
                      label: role?.roleName,
                      value: role?.id,
                    })) || []
                  }
                  onChange={(value) => {
                    const selectedRole = allsRollData?.find(
                      (r: any) => r.id === value
                    );
                    setSelectedRoleName(selectedRole?.roleName || "");
                  }}
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                  disabled={!selectedProjectId}
                />
              </Form.Item>

              {["Approver"].includes(selectedRoleName) && (
                <Form.Item
                  label="Select Wallet"
                  name="wallet_number"
                  rules={[{ required: true, message: "Please select wallet" }]}
                >
                  <Select
                    placeholder="Select Wallet"
                    className="w-full"
                    suffixIcon={<SelectDownIcon />}
                    allowClear
                    // options={
                    //   getCompanyWalletData?.data?.map((item: any) => ({
                    //     label: item.name,
                    //     value: item.name,
                    //   })) || []
                    // }
                  />
                </Form.Item>
              )}
            </div>

            {/* <div className="justify-start">
              <div className="flex items-center justify-start text-blue-600 text-sm font-semibold mb-4 cursor-pointer">
                <AddIcon /> <span className="ml-2">Add New Amount</span>
              </div>

              <div className="justify-start text-slate-700 text-sm font-normal italic mb-4">
                Note: Select minimum 2 approvers from any set
              </div>
            </div> */}
          </CustomCard>

          {/* sticky bottom-0 */}
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link to={backLink}>
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              {id ? (
                <Button
                  className="modal-button"
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  loading={updateWorkFlowLoading}
                >
                  Update
                </Button>
              ) : (
                <Button
                  className="modal-button"
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  loading={isCreateWorkFlowLoading}
                >
                  Save
                </Button>
              )}
            </Space>
          </div>
        </Form>
      </SidebarLayout>
    </>
  );
}
